import { decryption } from "./encryption/encryption";

export const isUserInfoExist = (object: Object | Storage) => {
  return Object.keys(object).findIndex(
    (element) => decryption(element) === "user"
  );
};
